import { render } from "./GoHome.vue?vue&type=template&id=5025d736&scoped=true"
import script from "./GoHome.vue?vue&type=script&lang=js"
export * from "./GoHome.vue?vue&type=script&lang=js"

import "./GoHome.vue?vue&type=style&index=0&id=5025d736&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eszti-isti.donko.hu/eszti-isti.donko.hu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5025d736"]])

export default __exports__